import { render, staticRenderFns } from "./EditHealthCheckLoader.vue?vue&type=template&id=79c64cf8"
import script from "./EditHealthCheckLoader.vue?vue&type=script&lang=ts"
export * from "./EditHealthCheckLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports